module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.svg?55c57a74937e6de260b67c62522f7ea1";